module.exports = __webpack_public_path__ + "static/img/scsp.49345a0b.png";